import { emailValidationRegex } from "constants/emailValidationRegex";

export const isValidEmail = (email: string): boolean =>
  emailValidationRegex.test(email);
